import { useQuery } from '@tanstack/react-query';
import { IAggregateActiveUse } from '../../../models/AdminModels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { IAccountsFilterRequest } from '../../../viewmodels/AdminViewModels';
import { handle404AsNull } from '../../utils';

const BASE_QUERY_KEY = `admin/account/stats`;

export function useAdminAccountStats({ filter }: { filter: IAccountsFilterRequest }) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: [BASE_QUERY_KEY, filter],
		queryFn: handle404AsNull(async () => {
			const result = await userSession.webServiceHelper.callAsync<IAggregateActiveUse>(
				`admin/account/stats`,
				'POST',
				filter
			);
			return result;
		}),
	});
}
